import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";
import { Toaster } from "@/components/ui/sonner";

export const AppShell = () => {
  return (
    <div className="min-h-screen bg-[#eef2f9] text-slate-900 flex">
      <Sidebar />
      <div className="flex-1 min-w-0 flex flex-col">
        <TopBar />
        <main className="flex-1 p-4 md:p-6 bg-grid">
          <Outlet />
        </main>
      </div>
      <Toaster theme="light" position="top-right" />
    </div>
  );
};
